<template>
  <SpinnerComp v-if="loading" />
  <div v-else>
    <div class="mt-10">
      <div class="flex items-center mb-6">
        <h1 class="text-2xl font-semibold text-blue-700 mr-4">
          Orden de Compra
        </h1>
        <input
          type="text"
          :value="cotizacion.idOC"
          class="rounded-md border border-gray-300 px-4 py-2 md:w-1/6 lg:md:w-1/6 w-full shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div class="flex items-center">
        <p class="text-lg text-red-700 font-semibold">
          <strong class="text-blue-700">De Cotización:</strong>
          {{ cotizacion.id }}
        </p>
      </div>
    </div>

    <h2 class="text-xl font-semibold mb-4 mt-6 flex justify-center">
      Datos Productos
    </h2>
    <div class="overflow-x-auto">
      <table class="w-full text-sm border-collapse">
        <thead>
          <tr class="bg-gray-700 text-white">
            <th class="px-3 py-2">Cantidad</th>
            <th class="px-3 py-2">Unidad</th>
            <th class="px-3 py-2">Stock</th>
            <th class="px-3 py-2">SKU</th>
            <th class="px-3 py-2">Descripción</th>
            <th class="px-3 py-2">P.U.</th>
            <th class="px-3 py-2">Importe</th>
            <th class="px-3 py-2">Proveedor</th>
            <th class="px-3 py-2">Cotización P.</th>
            <th class="px-3 py-2">Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="producto in cotizacion.productos"
            :key="producto.sku"
            class="border-b"
          >
            <td class="px-3 py-2 w-24">
              <input
                type="text"
                v-model="producto.cantidad"
                class="w-full px-3 py-2 border rounded-md"
                @change="actualizarImporte(producto)"
              />
            </td>
            <td class="px-3 py-2">{{ producto.unidad }}</td>
            <td class="px-3 py-2">{{ producto.stock }}</td>
            <td class="px-3 py-2">{{ producto.sku }}</td>
            <td class="px-3 py-2">
              <div
                v-if="producto.sku === 'Embalaje' || producto.sku === 'Envío'"
              >
                <input
                  type="text"
                  v-model="producto.descripcion"
                  class="w-full px-3 py-2 border rounded-md"
                />
              </div>
              <div v-else>
                {{ producto.descripcion }}
              </div>
            </td>

            <td class="px-3 py-2">
              <input
                type="text"
                v-model="producto.precio"
                class="w-24 px-3 py-2 border rounded-md"
                @change="actualizarImporte(producto)"
              />
            </td>
            <td class="px-3 py-2">
              ${{ parseFloat(producto.importe).toFixed(2) }}
            </td>
            <td class="px-3 py-2">{{ producto.proveedor }}</td>
            <td class="px-3 py-2">{{ producto.cotizacionP }}</td>
            <td class="px-3 py-2 flex items-center justify-center">
              <button
                @click="eliminarProducto(producto.sku)"
                class="bg-red-500 text-white rounded-full w-10 h-10"
              >
                <i class="fas fa-trash-alt text-lg"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="text-right mt-6">
      <p>
        <strong>Subtotal:</strong> ${{
          parseFloat(cotizacion.total).toFixed(2)
        }}
      </p>
      <p><strong>IVA:</strong> ${{ iva.toFixed(2) }}</p>
      <p><strong>TOTAL:</strong> ${{ (cotizacion.total + iva).toFixed(2) }}</p>
    </div>

    <div class="flex justify-center mt-6">
      <button
        class="bg-yellow-500 hover:bg-yellow-400 rounded py-2 px-4 text-white"
        @click="agregarProducto('embalaje')"
      >
        Embalaje
      </button>
      <button
        class="bg-yellow-500 hover:bg-yellow-400 rounded py-2 px-4 text-white ml-4"
        @click="agregarProducto('envio')"
      >
        Envío
      </button>
    </div>

    <div class="bg-white p-6 rounded-lg shadow-md mt-6">
      <h2 class="text-xl font-semibold mb-4 flex justify-center">
        Datos del Proveedor
      </h2>
      <div class="grid grid-cols-2 gap-6 md:grid-cols-2 lg:grid-cols-2">
        <div class="col-span-1">
          <label class="block mb-2">Nombre</label>
          <input
            type="text"
            v-model="proveedor.nombreP"
            placeholder="Ingrese el nombre del proveedor"
            @input="filterProveedores"
            class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
          />
          <ul
            v-if="proveedor.nombreP && filteredProveedores.length"
            class="mt-2 border border-gray-300 rounded-lg"
          >
            <li
              v-for="filteredProveedor in filteredProveedores"
              :key="filteredProveedor.id"
              @click="selectProveedor(filteredProveedor)"
              class="cursor-pointer p-2 hover:bg-gray-200"
            >
              {{ filteredProveedor.nombreP }}
            </li>
          </ul>
        </div>

        <div class="col-span-1">
          <label class="block mb-2">RFC</label>
          <input
            type="text"
            v-model="proveedor.rfcP"
            disabled
            class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
          />
        </div>
      </div>
      <div class="grid grid-cols-2 gap-6 md:grid-cols-2 lg:grid-cols-3">
        <div>
          <label class="block mb-2">Calle y Número</label>
          <input
            type="text"
            v-model="proveedor.calleP"
            disabled
            class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
          />
        </div>
        <div>
          <label class="block mb-2">Colonia y Código Postal</label>
          <input
            type="text"
            v-model="proveedor.coloniaP"
            disabled
            class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
          />
        </div>
        <div>
          <label class="block mb-2">Municipio</label>
          <input
            type="text"
            v-model="proveedor.municipioP"
            disabled
            class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
          />
        </div>
        <div>
          <label class="block mb-2">Credito</label>
          <input
            type="text"
            v-model="proveedor.creditoP"
            disabled
            class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
          />
        </div>
        <div>
          <label class="block mb-2">Dias de Credito</label>
          <input
            type="text"
            v-model="proveedor.plazoP"
            disabled
            class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
          />
        </div>
        <div>
          <label class="block mb-2">Importe</label>
          <input
            type="text"
            v-model="proveedor.importeP"
            disabled
            class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
          />
        </div>
        <div>
          <label class="block mb-2">Credito Restante</label>
          <input
            type="text"
            v-model="proveedor.saldoRestanteP"
            disabled
            class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
          />
        </div>
      </div>
    </div>
    <div class="bg-white p-6 rounded-lg shadow-md mt-6">
      <h2 class="text-xl font-semibold mb-4 flex justify-center">
        Datos del Vendedor
      </h2>
      <div class="grid grid-cols-2 gap-6">
        <div>
          <label class="block mb-2">Nombre:</label>
          <input
            type="text"
            v-model="vendedor.nombreV"
            @input="filterVendedores"
            class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
          />
          <ul
            v-if="vendedor.nombreV && filteredVendedores.length"
            class="mt-2 border border-gray-300 rounded-lg"
          >
            <li
              v-for="filteredVendedor in filteredVendedores"
              :key="filteredVendedor.idV"
              @click="selectVendedor(filteredVendedor)"
              class="cursor-pointer p-2 hover:bg-gray-200"
            >
              {{ filteredVendedor.nombreV }}
            </li>
          </ul>
        </div>

        <div>
          <label class="block mb-2">Teléfono:</label>
          <input
            type="text"
            v-model="vendedor.telefonoV"
            class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
          />
        </div>
        <div>
          <label class="block mb-2">Correo:</label>
          <input
            type="text"
            v-model="vendedor.correoV"
            class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
          />
        </div>
      </div>
    </div>

    <div class="bg-white p-6 rounded-lg shadow-md mt-6">
      <h2 class="text-xl font-semibold mb-4 flex justify-center">
        Datos Orden de Compra
      </h2>
      <div>
        <label class="block mb-2">Referencia</label>
        <input
          type="text"
          :value="cotizacion.referenciaOC"
          class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
        />
      </div>
      <div class="mt-6">
        <label class="block mb-2">Uso CFDI</label>
        <select
          v-model="cotizacion.usoOC"
          class="w-full border border-gray-300 rounded px-3 py-2"
        >
          <option value="G01">G01: Adquisición de mercancías</option>
          <option value="G03">G03: Gasto General</option>
          <option value="P01">P01: Por definir</option>
        </select>
      </div>
      <div class="mt-6">
        <label class="block mb-2">Moneda</label>
        <select
          v-model="cotizacion.monedaOC"
          class="w-full border border-gray-300 rounded px-3 py-2"
        >
          <option value="sel">Seleccionar</option>
          <option value="MXN">Pesos</option>
          <option value="USD">Dólares</option>
        </select>
      </div>
    </div>

    <div class="flex justify-center mt-6 mb-4">
      <button
        @click="generarOrden"
        class="bg-green-500 hover:bg-green-400 rounded py-2 px-4 text-white"
      >
        Generar Orden de compra
      </button>
    </div>
  </div>
</template>
<script>
import SpinnerComp from "@/components/SpinnerComp.vue";
export default {
  components: {
    SpinnerComp,
  },
  data() {
    return {
      cotizacion: {
        id: "",
        referenciaOC: "",
        codigo: "",
        productos: [],
        subtotal: 0,
        iva: 0,
        total: 0,
        cliente: {},
        colabcliente: {},
        estado: "",
      },
      proveedor: {
        nombreP: "",
        rfcP: "",
        calleP: "",
        coloniaP: "",
        municipioP: "",
        creditoP: "",
        plazoP: "",
        importeP: "",
        saldoRestanteP: "",
      },
      loading: true,
      vendedor: {
        nombreV: "",
        correoV: "",
        telefonoV: "",
      },
      vendedores: [],
      filteredVendedores: [],
      proveedores: [],
      filteredProveedores: [],
    };
  },
  methods: {
    getData() {
      this.loading = true;
      const cotId = this.$route.params.id;      
      this.$axios
        .get(`/getCotOne/${cotId}`)
        .then((response) => {
          const data = response.data.cotizacion;
          this.cotizacion.id = data.id;
          this.cotizacion.referenciaOC = data.referencia;
          this.cotizacion.monedaOC = data.moneda;
          this.cotizacion.codigo = data.codigo || "";
          this.cotizacion.precio = data.precio;

          this.cotizacion.productos = data.detalle_cotizaciones.map((item) => ({
            id_producto: item.producto.id,
            cantidad: item.cantidad,
            descripcion: item.producto.descripcion,
            sku: item.producto.sku,
            stock: item.producto.existencia,
            unidad: item.producto.unidad,
            precio: item.producto.precioUtil,
            importe: item.cantidad * item.precio,
            proveedor: item.producto.proveedor.nombreP,
            cotizacionP: item.producto.cotProP,
          }));
          this.actualizarTotal();
          console.log(this.cotizacion.productos);
        })
        .catch((error) => {
          alert(error.response.data.message);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    agregarProducto(tipo) {
      const existeProducto = this.cotizacion.productos.some(
        (producto) =>
          producto.sku === (tipo === "embalaje" ? "Embalaje" : "Envío")
      );

      if (existeProducto) return;

      const nuevoProducto = {
        id_producto: tipo === "embalaje" ? 76 : 95,
        cantidad: 1,
        unidad: 0,
        stock: 0,
        sku: tipo === "embalaje" ? "Embalaje" : "Envío",
        descripcion: tipo === "embalaje" ? "Embalaje" : "Envío",
        precio: 0,
        importe: 0,
        proveedor: "Sin proveedor",
      };

      this.cotizacion.productos.push(nuevoProducto);
      this.actualizarTotal();
    },

    eliminarProducto(sku) {
      const index = this.cotizacion.productos.findIndex(
        (producto) => producto.sku === sku
      );
      if (index !== -1) {
        this.cotizacion.productos.splice(index, 1);
        this.actualizarTotal();
      }
    },
    actualizarImporte(producto) {
      producto.importe = producto.cantidad * producto.precio;
      this.actualizarTotal();
    },
    actualizarTotal() {
      this.cotizacion.total = this.cotizacion.productos.reduce(
        (total, producto) => total + producto.importe,
        0
      );
    },
    generarId() {
      const cotId = this.$route.params.id;
      this.$axios.get(`/generate-id-OC/${cotId}`).then((response) => {
        this.cotizacion.idOC = response.data.idNuevo;
      });
    },
    filterProveedores() {
      if (this.proveedores && Array.isArray(this.proveedores)) {
        this.filteredProveedores = this.proveedores.filter((proveedor) =>
          proveedor.nombreP
            .toLowerCase()
            .includes(this.proveedor.nombreP.toLowerCase())
        );
      } else {
        console.error("Proveedores no están disponibles para filtrar");
      }
    },
    selectProveedor(proveedor) {
      this.proveedor = { ...proveedor };
      this.filteredProveedores = [];
      this.idProveedor = proveedor.idP;
      this.getInformation(this.idProveedor);
    },
    filterVendedores() {
      const query = this.vendedor.nombreV.toLowerCase();
      this.filteredVendedores = this.vendedores.filter((vendedor) =>
        vendedor.nombreV.toLowerCase().includes(query)
      );
    },
    selectVendedor(vendedor) {
      this.vendedor = { ...vendedor };
      this.filteredVendedores = [];
    },
    getInformation(idProveedor) {
      this.$axios
        .get("/getPrv")
        .then((response) => {
          this.proveedores = response.data.proveedores;
        })
        .catch((error) => {
          console.error("hay un error con proveedores", error.response);
        });

      this.$axios
        .get(`/vendedores/${idProveedor}`)
        .then((response) => {
          this.vendedores = response.data.vendedores;
        })
        .catch((error) => {
          console.error("hay un error con vendedores", error.response);
        });
    },
    generarOrden() {
      this.$axios
        .post("/registerOrd", {
          cotizacion: this.cotizacion,
          proveedor: this.proveedor,
          vendedor: this.vendedor,
        })
        .then((response) => {
          alert(response.data.message);
          this.generatePdf(response.data.idOC);
          this.$router.push("/ordenes_compra");
        })
        .catch((error) => {
          alert("Hay campos sin completar.");
          console.error("Error al generar la orden de compra:", error);
        });
    },
    generatePdf(id) {
      this.$axios
        .get(`/generate-pdf-OC/${id}`, {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);

          const newTab = window.open(url, "_blank");
          if (!newTab) {
            alert(
              "No se pudo abrir el PDF en una nueva ventana. Asegúrate de que las ventanas emergentes no estén bloqueadas."
            );
          }

          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          alert(error.response?.data?.message || "Error al generar el PDF");       
          console.log(error);   
        });
    },
  },
  computed: {
    iva() {
      return this.cotizacion.total * 0.16;
    },
  },
  mounted() {
    this.getData();
    this.generarId();
    this.getInformation();
  },
};
</script>
